export enum PositionState {
  NotChanged,
  Decreased,
  Increased,
}

export interface UserReward {
  earned: string
  user: string
  leaderBoardPositionState: PositionState
}
